import { Status } from '@philo/web-shared';

export interface AuthState {
  authCode: string;
  authCodeStatus?: Status;
  errorCode: null | number;
  inputFocused: true;
  inputStatus?: Status;
  isAuthRequestFailed: boolean;
  isAuthRestartRequired: boolean;
  isPossibleLoginAttempt: boolean;
  isSendingAuthRequest: boolean;
  isUserInPhiloSupportedGeoRegion: boolean;
  location?: string;
  message: string;
  shouldRequestAuthNewCode: boolean;
  zipInputStatus?: Status;
}

const initialState: AuthState = {
  authCode: '',
  authCodeStatus: undefined,
  errorCode: null,
  inputFocused: true,
  inputStatus: undefined,
  isAuthRequestFailed: false,
  isAuthRestartRequired: false,
  isPossibleLoginAttempt: false,
  isSendingAuthRequest: false,
  isUserInPhiloSupportedGeoRegion: true,
  message: '',
  shouldRequestAuthNewCode: false,
  zipInputStatus: undefined,
};

export default initialState;
